module.exports = __webpack_public_path__ + "img/email.bfa519b.svg";